import { SwapXyroToken } from 'shared/icons'
import { DemoCoinIcon } from 'shared/ui/demo-amount'
import { TetherToken } from 'shared/ui/tether-token'

interface Props {
  /** The off-chain demo: the demo coin, not USDT. */
  isDemo?: boolean
  isGameForXyroToken?: boolean
}

/** The unit of a participant's stake: the demo coin off-chain, else the game's token. */
export const ParticipantBetToken = ({ isDemo, isGameForXyroToken }: Props) => {
  if (isDemo) {
    return (
      <DemoCoinIcon
        size={'2rem'}
        color='yellow'
      />
    )
  }

  return isGameForXyroToken ?
      <SwapXyroToken
        width={'2rem'}
        height={'2rem'}
      />
    : <TetherToken
        size={'2rem'}
        color='yellow'
      />
}
